import type { IconSvgObject } from './types';

const ArrowUpDoubleIcon: IconSvgObject = [
  ["path", { d: "M6.00002 11.4998L12 5.49976L18 11.4997", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "0" }],
  ["path", { d: "M6.00002 18.4998L12 12.4998L18 18.4997", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "1" }]
];

export default ArrowUpDoubleIcon;
